// extracted by mini-css-extract-plugin
export default {"root":"embeded_root__wulEw","embeded":"embeded_embeded__fs0FR","title":"embeded_title__AHHAB","loader":"embeded_loader__CZd26","btn":"embeded_btn__PK3pQ"};